/* React */
import React from "react";

/* Components */
import InsightsFilter from "src/components/insights/insights-filter/InsightsFilter";
import InsightsOptions from "src/components/insights/insights-options/InsightsOptions";

const InsightsFilterMenu: React.FC = () => {
  return (
    <>
      <InsightsFilter />
      <InsightsOptions />
    </>
  );
};

export default InsightsFilterMenu;
